import "@/App.css";

const ThankYouPage = () => {
  return (
    <div className="thank-you-page" data-testid="thank-you-page">
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MR52SPMT"
        height="0" width="0" style={{display:'none',visibility:'hidden'}}></iframe>
      </noscript>

      {/* Decorative top bar */}
      <div className="top-accent-bar"></div>
      
      <main className="thank-you-content">
        {/* Small decorative label */}
        <span className="section-label" data-testid="section-label">
          CONFIRMATION
        </span>
        
        {/* Main heading */}
        <h1 className="thank-you-heading" data-testid="thank-you-heading">
          Thank You for Reaching Out
        </h1>
        
        {/* Message */}
        <p className="thank-you-message" data-testid="thank-you-message">
          We've received your inquiry and our team will review it shortly.
          <br />
          Expect to hear from us soon.
        </p>

        {/* Decorative element */}
        <div className="decorative-line"></div>
      </main>
    </div>
  );
};

function App() {
  return <ThankYouPage />;
}

export default App;